module.exports = __webpack_public_path__ + "static/img/bg.5bd7edd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/limit-activity/bg.png
// module id = AG7V
// module chunks = 215